import { Component } from '@angular/core';
import { HocuspocusProvider } from '@hocuspocus/provider';
import { environment } from 'src/environments/environment';
import { Account } from 'src/sync/account';
import { YMap } from 'yjs/dist/src/internals';

export type gameclass = 'fighter' | 'magic-user' | 'cleric' | 'thief';

export interface ICampaign {
    expeditions: IExpedition[];
    characters: ICharacter[];
}

export interface IExpedition {
    id: number;
    experience: number;
    date?: Date;
}

export interface ICharacter {
    name: string;
    classList: gameclass[];
    magicItems: string[];
}

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign.component.scss'],
    standalone: false
})
export class CampaignComponent {
    public current: any;
    public currentType: 'character' | 'expedition' = 'character';
    public campaign!: ICampaign;
    public game!: YMap<{}>;

    constructor() {
        const startup = async () => {
            const provider = await this.connectCampaign();
            this.game = provider.document.getMap('game');
            this.campaign = this.game.get('campaign') as ICampaign;
            if (this.campaign == null) {
                this.game.set('campaign', {
                    characters: [],
                    expeditions: []
                });
                this.campaign = this.game.get('campaign') as ICampaign;
            }
        };
        startup();
    }

    public save() {
        this.game.set('campaign', this.campaign);
    }

    public newCharacter() {
        const char: ICharacter = {
            name: `default ${this.campaign.characters.length + 1}`,
            classList: ['magic-user'],
            magicItems: []
        };
        this.campaign.characters.push(char);
        this.current = char;
        this.currentType = 'character';
        this.save();
    }

    public async connectCampaign(): Promise<HocuspocusProvider> {
        const token = await Account.provider.getToken();

        return new Promise((resolve, reject) => {
            const campaignProvider: HocuspocusProvider = new HocuspocusProvider({
                url: environment.websocketUrl,
                name: 'campaign-tracker',
                token: token,
                onAuthenticationFailed: (error) => reject(error)

            });

            campaignProvider.on('synced', () => resolve(campaignProvider));
        });
    }
}
